<template>
  <div class="uiblock">
    <div v-if="customLabel" class="label">
      {{ customLabel }}
    </div>
    <div v-else-if="defaultLabel" class="label">
      {{ $t('Import an existing bill of quantities as an') }}
      <strong>.xlsx</strong>
      {{ $t('or') }}
      <strong>.csv</strong>
      {{ $t('file. Later you may upload it or fill in fields manually.') }}
    </div>
    <div v-else class="label">
      <slot name="label" />
    </div>
    <div class="attach spacey-8">
      <FileUpload
        v-if="files.length < maxCount"
        :files="files"
        :allowed-formats="allowedFormats"
        :disallowed-formats="disallowedFormats"
        :max-count="maxCount"
        :max-size="maxSize"
        @select="handleSelect"
      >
        <div class="block-attach spacey-8">
          <Icon type="upload" size="20" color="secondary" />
          <div class="text-mr text-tertiary">
            {{ $t('Drop file here or') }}
          </div>
          <Button type="secondary">
            {{ $t('Choose file') }}
          </Button>
        </div>
      </FileUpload>
      <div v-if="!!error" class="error-message">{{ error }}</div>
      <div v-if="description" class="attach__description">
        {{ description }}
      </div>
      <div v-for="(file, idx) in filesList" :key="idx" class="file-attach spacex-12">
        <div class="column-attach spacex-8">
          <Icon type="file" size="20" />
          <Spinner v-if="isLoading" size="20" />
          <div v-else class="text-sm flex-1 column-attach__name">
            {{ file.name }}
          </div>
          <div v-if="!isLoading" class="text-sm text-tertiary">
            {{ (file.size / (1024 * 1024)).toFixed(2) }} {{ $t('Mb') }}
          </div>
        </div>
        <Button class="button-attach" type="func" icon="x" @click="deleteFile(idx, file)" />
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from 'vue-simple-spinner';
  import FileUpload from '@/components/ui/FileUpload';
  import Button from '@/components/ui-v2/Button';
  import uploadFiles from '@/utils/mixins/upload-files';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'FileAttachment',
    components: { Icon, FileUpload, Button, Spinner },
    mixins: [uploadFiles],
    props: {
      files: {
        type: Array,
        required: false,
        default: () => [],
      },
      defaultLabel: {
        type: Boolean,
        default: true,
      },
      customLabel: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
      maxCount: {
        type: Number,
        default: 1,
      },
      allowedFormats: {
        type: [Array, null],
        default: () => ['xlsx', 'xls'],
      },
      disallowedFormats: {
        type: Array,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      maxSize: {
        type: Number,
        default: 100,
      },
      // Флаг на то чтобы файлы сразу загружались тут и наверх шли айдишники
      uploadInside: {
        type: Boolean,
        default: false,
      },
      error: [String, Boolean],
    },
    computed: {
      filesList() {
        return this.uploadInside ? this.fileLinks : this.files;
      },
    },
    methods: {
      handleSelect(files) {
        if (this.uploadInside) {
          this.uploadFiles(files);
        } else {
          this.$emit('file-input', files);
        }
      },
      deleteFile(idx, file) {
        if (this.uploadInside) {
          this.removeFile(file.id);
        } else {
          this.$emit('file-delete', idx);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'src/styles/colors';
  .attach {
    &__description {
      font-weight: 500;
      font-size: 12px;
      color: $text-tertiary;
      margin-bottom: 12px;
    }
  }
  .label {
    margin-bottom: 4px;
  }
  .uiblock {
    margin-bottom: 20px;
  }
  .block-attach {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 28px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px dashed #dadde2;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: #fff;
    text-align: center;
  }
  .column-attach {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    max-width: 95%;
  }
  .button-attach {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 100px;
    -webkit-transition: all 100ms ease-in-out;
    transition: all 100ms ease-in-out;
    cursor: pointer;
  }
  .column-attach__name {
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
